import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { BlogCard } from "@/components/blog/BlogCard";
import { useBlogPosts } from "@/hooks/api/blogPosts";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import SEOHead from "@/components/SEOHead";

export default function Blog() {
  const { data: posts, isLoading } = useBlogPosts();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Blog Immovox | Téléphone, relation client et IA immobilier"
        description="Guides Immovox sur la gestion des appels, la qualification des prospects et les usages de l’IA téléphonique en agence immobilière."
        canonical="/blog"
      />
      <Header />
      
      <main className="mx-auto max-w-[1344px] px-5 pb-20 pt-32 md:px-8">
        <div className="grid gap-8 border-b border-foreground/20 pb-12 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <p className="eyebrow mb-6">Ressources</p>
            <h1 className="text-4xl font-semibold tracking-[-.045em] md:text-6xl">Téléphone, relation client et IA dans l'immobilier.</h1>
          </div>
          <p className="text-[17px] leading-7 text-muted-foreground lg:col-span-4 lg:pt-14">
            Guides pratiques sur la gestion des appels, la qualification des prospects et les usages de l'IA téléphonique en agence.
          </p>
        </div>

        {/* Loading state */}
        {isLoading && (
          <div className="mt-10 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="h-80 animate-pulse rounded-xl bg-muted"
              />
            ))}
          </div>
        )}

        {/* Empty state */}
        {!isLoading && (!posts || posts.length === 0) && (
          <div className="flex flex-col items-center justify-center py-24 text-center">
            <div className="rounded-full bg-muted p-6 mb-6">
              <FileText className="h-12 w-12 text-muted-foreground" />
            </div>
            <h2 className="text-2xl font-semibold text-foreground mb-2">
              Aucun article pour le moment
            </h2>
            <p className="text-muted-foreground max-w-md">
              Nous préparons du contenu de qualité. Revenez bientôt pour découvrir 
              nos premiers articles !
            </p>
          </div>
        )}

        {/* Articles grid */}
        {!isLoading && posts && posts.length > 0 && (
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {posts.map((post) => (
              <BlogCard key={post.id} post={post} />
            ))}
          </div>
        )}
      </main>

      <Footer />
      <ExitIntentPopup />
    </div>
  );
}
